import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { COMMUNICATION_URL, GET_BOOKING_COMMUNICATIONS_URL, GET_SENT_COMMUNICATIONS_URL, SEND_MESSAGE_URL } from "./urls_b2b";
import { Observable } from "rxjs";

@Injectable()
export class CommunicationService {
    constructor(private baseService: BaseService) {
    }

    getAll(params) {
        return this.baseService.tokenGetRequest(this.baseService.buildUrl(COMMUNICATION_URL,params));
    }

    getSent(params){
        return this.baseService.tokenGetRequest(this.baseService.buildUrl(GET_SENT_COMMUNICATIONS_URL,params));
    }

    getBookingCommunications(id: any) {
        return this.baseService.tokenGetRequest(this.baseService.buildUrl(GET_BOOKING_COMMUNICATIONS_URL,{booking_id: id}));
    }

    markAsRead(payload): Observable<any> {
        return this.baseService.tokenPutRequest(COMMUNICATION_URL, payload);
    }

    sendMessage(payload: any): Observable<any> {
        return this.baseService.tokenPostRequest(SEND_MESSAGE_URL ,payload);
    }
}
